import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddedTripTypePageRoutingModule } from './added-trip-type-routing.module';

import { AddedTripTypePage } from './added-trip-type.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, AddedTripTypePageRoutingModule, TranslateModule.forChild()],
  declarations: [AddedTripTypePage]
})
export class AddedTripTypePageModule {}
